import { DIAGNOSIS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/diagnosisCorrectAnswers'
import { MULTIPLE_CHOICE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/multipleChoiceCorrectAnswers'
import { TEXT_OPTIONS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/textOptionsCorrectAnswers'
import { TRUE_FALSE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/trueFalseCorrectAnswers'
import { PageId } from '~/shared/constants/pagesConstants'

export interface IScoredSection {
  scoredPageIds: PageId[]
  correctAnswersRegistry: Partial<Record<PageId, string>>
  pointsPerQuestion: number
}

// Single source of truth for "which pages count, against which answer key,
// worth how many points" per section — used by both the sectionXComplete
// celebration screens and the learningProfile total-score summary, so they
// can never silently disagree.
export const SECTION_2_SCORING: IScoredSection = {
  scoredPageIds: [
    PageId.SPOT_THE_FAKE_ANATOMY_V2_1,
    PageId.SPINE_POSTURE_ANATOMY_V2_1,
    PageId.WATER_DIGESTION_ANATOMY_V2_1,
    PageId.HIP_FLEXOR_ANATOMY_V2_1,
  ],
  correctAnswersRegistry: TRUE_FALSE_CORRECT_ANSWERS,
  pointsPerQuestion: 5,
}

export const SECTION_3_SCORING: IScoredSection = {
  scoredPageIds: [
    PageId.STRONGEST_MUSCLE_ANATOMY_V2_1,
    PageId.SMALLEST_BONE_ANATOMY_V2_1,
    PageId.ORGAN_REGENERATES_ANATOMY_V2_1,
    PageId.POSTURE_INFLUENCE_ANATOMY_V2_1,
  ],
  correctAnswersRegistry: MULTIPLE_CHOICE_CORRECT_ANSWERS,
  pointsPerQuestion: 5,
}

export const SECTION_4_SCORING: IScoredSection = {
  scoredPageIds: [
    PageId.LOWER_BACK_PAIN_ANATOMY_V2_1,
    PageId.NECK_STRAIN_ANATOMY_V2_1,
    PageId.SHOULDER_PAIN_ANATOMY_V2_1,
    PageId.VAGUS_NERVE_ANATOMY_V2_1,
  ],
  correctAnswersRegistry: TEXT_OPTIONS_CORRECT_ANSWERS,
  pointsPerQuestion: 5,
}

export const SECTION_5_SCORING: IScoredSection = {
  scoredPageIds: [
    PageId.DIAGNOSIS_HEADACHE_ANATOMY_V2_1,
    PageId.DIAGNOSIS_SHOULDER_ANATOMY_V2_1,
    PageId.DIAGNOSIS_HIP_ANATOMY_V2_1,
  ],
  correctAnswersRegistry: DIAGNOSIS_CORRECT_ANSWERS,
  pointsPerQuestion: 10,
}

export const ALL_SCORED_SECTIONS: IScoredSection[] = [
  SECTION_2_SCORING,
  SECTION_3_SCORING,
  SECTION_4_SCORING,
  SECTION_5_SCORING,
]
